// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3IXSG","fr":"_2tPFN","en":"rlnKh","title":"aPitF"};